module.exports = __webpack_public_path__ + "static/media/office.f4a608b3.svg";